/** Golden fist (fx 'vajra'): a palm-shaped shockwave; long-range palms send a golden wave. */
import { registerFx } from './registry';

registerFx('vajra', (host) => ({
  skill: ({ src, tgt, sx, sy, tx, ty }) => {
    host.swingArc(src, 'palm', '255,214,110');
    if (tgt) {
      if (Math.hypot(tgt.x - src.x, tgt.y - src.y) > 2)
        host.fx.push({
          type: 'wave',
          x: sx,
          y: sy - 18,
          t: 0,
          life: 0.2,
          x1: tx,
          y1: ty - 14,
          col: '255,214,110',
        });
      host.fx.push({ type: 'ring', x: tx, y: ty, t: 0, life: 0.4, r: 26, col: '255,214,110' });
      host.burst(tx, ty - 14 * host.tall(tgt), 18, ['#ffe39a', '#fff4cf', '#f2b23a'], 90, 30, 0.5);
    }
    host.sfx.swing();
  },
}));
